module.exports = __webpack_public_path__ + "img/xlist(3).4034bf16.jpg";